<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-1">
      <h5 class="mb-0">Oturum Listesi</h5>
      <span v-if="parseFloat(total) > 0" class="badge badge-success"> <feather-icon icon="ClockIcon" size="14" class="mr-50" /> Toplam: {{ total }} saat </span>
    </div>
    <hr />

    <ul class="list-group list-group-flush">
      <li v-for="(session, index) in sessions" :key="index" class="list-group-item px-0 d-flex justify-content-between align-items-center" >
        <div>
          <div class="font-weight-bold">{{ index + 1 }}. Oturum</div>
            <div class="text-muted font-small-3">
              {{ formatDateTime(session.StartDateTime) }} <feather-icon icon="ArrowRightIcon" size="12" /> {{ formatDateTime(session.EndDateTime) }}
            </div>
          </div>
        <div class="badge badge-pill badge-light-primary">
          {{ getSessionDuration(session) }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    sessions: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    total() {
      return this.sessions
        .reduce((sum, s) => {
          const start = moment(s.StartDateTime.replace("T", " "), "YYYY-MM-DD HH:mm");
          const end = moment(s.EndDateTime.replace("T", " "), "YYYY-MM-DD HH:mm");
          const duration = moment.duration(end.diff(start));
          return sum + duration.asHours();
        }, 0)
        .toFixed(1);
    }
  },
  methods: {
    formatDateTime(dateString) {
      if (!dateString) return "";
      return moment(dateString.replace("T", " "), "YYYY-MM-DD HH:mm").format(
        "DD.MM.YYYY HH:mm"
      );
    },
    getSessionDuration(session) {
      if (session.StartDateTime && session.EndDateTime) {
        const start = moment( session.StartDateTime.replace("T", " "), "YYYY-MM-DD HH:mm" );
        const end = moment(session.EndDateTime.replace("T", " "), "YYYY-MM-DD HH:mm" );
        if (end.isAfter(start)) {
          const duration = moment.duration(end.diff(start));
          if (duration.asMinutes() < 60) {
            return `${duration.asMinutes().toFixed(0)} dk`;
          }
          return `${duration.asHours().toFixed(1)} saat`;
        }
      }
      return "-";
    },
  },
};
</script>